import { ChangeEvent } from "react";

interface IDSQNipComponent {
    onCloseCallback: () => void;
}

class DSQNipComponentState {
    public pin: string;

    constructor(s: DSQNipComponentState = null) {
        if (s != null) {
            this.pin = s.pin;
        }
        else {
            this.pin = "";
        }
    }
}

class DSQNipComponent extends React.Component<IDSQNipComponent, DSQNipComponentState> {
    constructor(props: IDSQNipComponent) {
        super(props);
        this.state = new DSQNipComponentState();
    }

    public componentDidMount(): void {
        sessionStore.showGlobalOverlay(true);
    }

    public componentWillUnmount(): void {
        sessionStore.hideGlobalOverlay();
    }

    public render(): JSX.Element {
        return (
            <div className="dsq-nip-popup">
                <div className="dsn-header">
                    <h4>DSQ {cacheStore.GetString("PINLabel")}</h4>
                </div>
                <div className="dsn-main">
                    <label className="push-right-5">{cacheStore.GetString("EnterPINLabel")}</label>
                    <input type="password" autoFocus={true} onKeyDown={e => this.onKeyDown(e)} value={this.state.pin} onChange={this.onPINTextChange.bind(this)} />
                </div>
                <div className="dsn-footer">
                    <div className="text-right">
                        <button className="btn btn-default push-right-5" onClick={() => this.props.onCloseCallback()}>{cacheStore.GetString("CancelLabel")}</button>
                        <button className="btn btn-default push-right-5" onClick={() => this.onNoDsqKeyClick()}>{cacheStore.GetString("btnIDontHaveMyDSQKey")}</button>
                        <button className="btn btn-primary" onClick={() => this.onOkClick()}>OK</button>
                    </div>
                </div>
            </div>
        );
    }

    private onPINTextChange(e: ChangeEvent<HTMLInputElement>): void {
        let value = e.target.value;
        var s = new DSQNipComponentState();
        s.pin = value;
        this.setState(s);
    }

    private onNoDsqKeyClick(): void {
        sessionStore.DSQPrescriptionDisabled = true;
        this.props.onCloseCallback();
    }

    private onOkClick(): void {
        sessionStore.DSQPin = this.state.pin;
        this.props.onCloseCallback();
    }

    private onKeyDown(e: React.KeyboardEvent): void {
        if (e.keyCode === 13) {
            this.onOkClick();
        }
    }
}

export { DSQNipComponent };
